module.exports = __webpack_public_path__ + "static/media/terminosSoftwone.eef72453.pdf";